// https://govuk-static.herokuapp.com/component-guide/government_navigation
import React from 'react';
import PropTypes from 'prop-types';
import UnorderedList from '@govuk-react/unordered-list';
import ListItem from '@govuk-react/list-item';
import { withWhiteSpace } from '@govuk-react/hoc'; // TODO use Context API https://github.com/reactjs/rfcs/blob/master/text/0002-new-version-of-context.md

var ListNavigation = function ListNavigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      listStyleType = _ref.listStyleType;
  return React.createElement(UnorderedList, {
    className: className,
    listStyleType: listStyleType
  }, children.length && children.map ? children.map(function (child, i) {
    return React.createElement(ListItem, {
      key: child.key || i
    }, child);
  }) : React.createElement(ListItem, null, children));
};

ListNavigation.defaultProps = {
  listStyleType: undefined,
  className: undefined
};
ListNavigation.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  listStyleType: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(ListNavigation);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/list-navigation/es/index.js
// module id = 85
// module chunks = 0